import React from 'react';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import {PaperProps, withStyles} from '@material-ui/core';

export interface InfoPanelProps extends PaperProps {
    message: string;
}

export const CODES = {
    infoMessage: 'epic.affiliate.fortnite_games.date_range_picker.calendar.message'
};

const InfoPanel = withStyles<string, undefined, InfoPanelProps>(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',

        height: theme.spacing(6),
        padding: theme.spacing(0, 2),
        // @ts-ignore
        color: theme.palette.dividerStrong,
        background: 'transparent',

        '&> span': {
            fontSize: '14px'
        }
    }
}))(({message, ...props}: InfoPanelProps) => (
    <Paper aria-label="info panel" {...props}>
        <Typography variant="body1" component="span">
            {message}
        </Typography>
    </Paper>
));

export default InfoPanel;
